// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Datepicker_wrapper__2kkQg","input":"Datepicker_input__35u1B"};